import { useCallback, useContext } from 'react';

import SearchServiceFiltersContext from '../../components/SearchServiceFiltersContext';
import {
  useClearLinesheetRows,
  useSetLinesheetScrollToIndex,
} from '../actionCreators';

export function useResetFilters() {
  const { resetFilters } = useContext(SearchServiceFiltersContext);
  const clearLinesheetRows = useClearLinesheetRows();
  const setLinesheetScrollToIndex = useSetLinesheetScrollToIndex();

  return useCallback(() => {
    resetFilters();
    clearLinesheetRows();
    setLinesheetScrollToIndex(0);
  }, []);
}
